import _ from 'lodash'

import { usePollingConfig, useUiConfig } from '../data'
import { ConfigContext, ConfigContextType } from './ConfigContext'
import { createDefaultConfig } from './createDefaultConfig'
import { defaultPollingConfig } from './defaultPollingConfig'

interface Props {
  children?: React.ReactNode
}

const ConfigContextProvider: React.FC<Props> = ({ children }) => {
  const { data: tenantConfig } = useUiConfig()
  const { data: pollingConfig } = usePollingConfig()

  // The function merge() from lodash merges default and tenant config.
  // If some fields are missing in the tenant config
  // they are taken from the default config.
  //
  // Testing
  // To test the defaultConfig just replace the tenantConfig with defaultConfig
  // in _.merge(defaultConfig, tenantConfig) -> _.merge(defaultConfig, defaultConfig)

  const config: ConfigContextType = {
    uiConfig: _.mergeWith(
      createDefaultConfig(),
      tenantConfig,
      (objValue, srcValue) => {
        // Only replace (not merge) the defaultConfig value if the ui-config
        // value has an array and in that array is a key with "requiredField"
        // so not the columns get touched.
        const hasRequiredField = _.some(srcValue, item =>
          _.has(item, 'requiredField'),
        )

        if (_.isArray(objValue) && _.isArray(srcValue) && hasRequiredField) {
          return srcValue
        }
      },
    ),
    pollingConfig: { ...defaultPollingConfig, ...pollingConfig },
  }

  return (
    <ConfigContext.Provider value={config}>
      <>{children}</>
    </ConfigContext.Provider>
  )
}

export default ConfigContextProvider
